import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import {CookieService} from "../services/cookie.service";
import {LoginRedirectService} from "../services/login-redirect.service";

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  // Inject the current `AuthService` and use it to get an authentication token:
  const session = inject(CookieService).getDesSession;
  const toLogin = inject(LoginRedirectService).goToLogin;

  if (req.headers.has('Authorization')) {
    return next(req);
  } else {
    if (!session()) {
      toLogin();
    }
    const requestAuth = req.clone({
      setHeaders: {
        Authorization: session(),
      },
    });
    return next(requestAuth);
  }
}
